import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12cfbac3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-feed-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "nge-feed-title" }, "Activity Feed"),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-feed-subtitle" }, "Live community proofreading activity")
], -1 /* HOISTED */))
const _hoisted_2 = {
  key: 0,
  class: "nge-feed-list"
}
const _hoisted_3 = { class: "nge-feed-icon" }
const _hoisted_4 = { class: "nge-feed-user" }
const _hoisted_5 = { class: "nge-feed-action" }
const _hoisted_6 = { class: "nge-feed-time" }
const _hoisted_7 = {
  key: 1,
  class: "nge-feed-empty"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-feed-empty-icon" }, "📡", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No activity yet. Start proofreading to see the feed come alive!", -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["ModalOverlay"], {
    class: "nge-feed-modal",
    onHide: _cache[1] || (_cache[1] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "nge-feed-shell",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        _hoisted_1,
        ($setup.feed.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.feed, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: _normalizeClass(["nge-feed-item", $setup.actionClass(item.action)])
                }, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString($setup.actionIcon(item.action)), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(item.user_name || 'Anonymous'), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.action), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_6, _toDisplayString($setup.timeAgo(item.timestamp)), 1 /* TEXT */)
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}